var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-6"},[_c('a-image-card',{on:{"show-dialog":function($event){_vm.showImageDialog = true}}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }